import { baseApi } from "./baseApi"
import type { WalletQueueSummary, WalletReviewItem } from "../../types/wallet"

export const walletApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getWalletReview: build.query<WalletReviewItem[], void>({
      query: () => ({ url: "/wallet/review", adminApi: "v1" }),
      providesTags: [{ type: "Wallet", id: "REVIEW" }],
    }),
    operationsQueue: build.query<WalletQueueSummary, void>({
      query: () => ({ url: "/wallet/queue", adminApi: "v1" }),
      providesTags: [{ type: "Wallet", id: "QUEUE" }],
    }),
    updateWalletReviewStatus: build.mutation<
      WalletReviewItem,
      { id: string; status: string; note?: string }
    >({
      query: ({ id, ...body }) => ({
        url: `/wallet/review/${id}/status`,
        method: "PATCH",
        body,
        adminApi: "v1",
      }),
      invalidatesTags: [
        { type: "Wallet", id: "REVIEW" },
        { type: "Wallet", id: "QUEUE" },
      ],
    }),
    createWalletAdjustment: build.mutation<
      WalletReviewItem,
      { userId: string; amount: number; reason?: string }
    >({
      query: (body) => ({ url: "/wallet/adjustments", method: "POST", body, adminApi: "v1" }),
      invalidatesTags: [
        { type: "Wallet", id: "REVIEW" },
        { type: "Wallet", id: "QUEUE" },
      ],
    }),
  }),
})

export const {
  useGetWalletReviewQuery,
  useOperationsQueueQuery,
  useUpdateWalletReviewStatusMutation,
  useCreateWalletAdjustmentMutation,
} = walletApi
